import React from "react";

function Filter({ onFilter }) {
  const classes = ["Support", "Medic", "Assault", "Defender", "Captain", "Witch"];

  return (
    <div className="filter">
      <label>Filter by class: </label>
      {classes.map((cls) => (
        <button key={cls} onClick={() => onFilter(cls)}>
          {cls}
        </button>
      ))}
    </div>
  );
}

export default Filter;
